import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <i className="ri-emotion-sad-line text-6xl text-foreground-300 mb-6 block"></i>
        <h1 className="text-xl md:text-2xl font-heading text-foreground-900 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-500">该页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 bg-primary-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}